import { Box, Button, Stack, Typography } from '@mui/material'
import React from 'react'
/**
 * @description
 * A component that renders a box with a title and a stack containing two buttons.
 * The first button is used to download a resume in docx format, and the second
 * button is used to download a resume in pdf format.
 * @param {function} handleDownloadResumePdf - A function that will be called when the download PDF button is clicked.
 * @param {boolean} loading - A boolean that indicates if the download is in progress.
 * @param {object} data - An object that contains the link and word_link properties of the resume.
 * @param {function} handleDownloadResumeDocs - A function that will be called when the download DocX button is clicked.
 * @returns {JSX} - The rendered component.
 */
const ResumeDownload = ({ handleDownloadResumePdf, loading, data, handleDownloadResumeDocs }) => {
  return (
    <Box className="ext-job-dialog-wraper">
      <Stack justifyContent={'center'}>
        <Box sx={{ textAlign: 'center' }} mb={3}>
          <Typography className="title" mb={1}>
            Download Resume
          </Typography>
        </Box>
        <Stack direction={{ xs: 'column-reverse', md: 'row' }} alignItems={'center'} spacing={2.5}>
          <Button fullWidth variant="outlined" size="medium"
            onClick={handleDownloadResumeDocs}
            disabled={loading || (!!data?.link && !data?.word_link)}
          >
            {loading ? 'Downloading...' : 'Download DocX (Word)'}
          </Button>

          <Button
            fullWidth
            variant="contained"
            size="medium"
            onClick={handleDownloadResumePdf}
            disabled={loading}
            sx={{
              '&.Mui-disabled': {
                color: 'rgba(145, 158, 171, 0.8) !important',
                boxShadow: 'none !important',
                backgroundColor: 'rgba(145, 158, 171, 0.24) !important',
              },
            }}
          >
            {loading ? 'Downloading...' : 'Download PDF'}
          </Button>
        </Stack>
      </Stack>
    </Box >
  )
}

export default ResumeDownload;
